
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { EmployeeFormData } from "@/types/employee";

interface ProfessionalInfoSectionProps {
  formData: EmployeeFormData;
  setFormData: (data: EmployeeFormData) => void;
}

export const ProfessionalInfoSection = ({ formData, setFormData }: ProfessionalInfoSectionProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-slate-800 border-b pb-2">المعلومات المهنية</h3>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="job_title">المسمى الوظيفي (اختياري)</Label>
          <Input
            id="job_title"
            value={formData.job_title}
            onChange={(e) => setFormData({...formData, job_title: e.target.value})}
            placeholder="مثال: مطور ويب"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="position">المنصب (اختياري)</Label>
          <Input
            id="position"
            value={formData.position}
            onChange={(e) => setFormData({...formData, position: e.target.value})}
            placeholder="مثال: موظف استقبال"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="department">القسم (اختياري)</Label>
          <Select value={formData.department} onValueChange={(value) => setFormData({...formData, department: value})}>
            <SelectTrigger>
              <SelectValue placeholder="اختر القسم (اختياري)" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="المرشدين">المرشدين</SelectItem>
              <SelectItem value="المبيعات">المبيعات</SelectItem>
              <SelectItem value="العمليات">العمليات</SelectItem>
              <SelectItem value="الإدارة">الإدارة</SelectItem>
              <SelectItem value="غير محدد">غير محدد</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="hiring_date">تاريخ التعيين (اختياري)</Label>
          <Input
            id="hiring_date"
            type="date"
            value={formData.hiring_date}
            onChange={(e) => setFormData({...formData, hiring_date: e.target.value})}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="working_hours">ساعات العمل اليومية (اختياري)</Label>
          <Input
            id="working_hours"
            type="number"
            value={formData.working_hours}
            onChange={(e) => setFormData({...formData, working_hours: parseInt(e.target.value) || 8})}
            placeholder="8"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="salary">الراتب (ريال) (اختياري)</Label>
          <Input
            id="salary"
            type="number"
            step="0.01"
            value={formData.salary}
            onChange={(e) => setFormData({...formData, salary: e.target.value})}
            placeholder="0.00"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="job_responsibilities">المهام الوظيفية (اختياري)</Label>
        <Textarea
          id="job_responsibilities"
          value={formData.job_responsibilities}
          onChange={(e) => setFormData({...formData, job_responsibilities: e.target.value})}
          rows={3}
          placeholder="اكتب المهام الوظيفية للموظف..."
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="job_description">الوصف الوظيفي (اختياري)</Label>
        <Textarea
          id="job_description"
          value={formData.job_description}
          onChange={(e) => setFormData({...formData, job_description: e.target.value})}
          rows={3}
          placeholder="اكتب الوصف الوظيفي للموظف..."
        />
      </div>
    </div>
  );
};
